import { useTranslation } from 'react-i18next';
import type { ProposedChangeRow } from './proposedPetChanges';

interface PetChangesListProps {
  changes: ProposedChangeRow[];
  isNewPet: boolean;
}

export function PetChangesList({ changes, isNewPet }: PetChangesListProps) {
  const { t } = useTranslation('intake');

  return (
    <div>
      <p className="text-xs font-bold uppercase tracking-wider text-zoomuted mb-1.5">
        {isNewPet ? t('reviewSection.newPetDetailsTitle') : t('reviewSection.petChangesTitle')}
      </p>
      {changes.length === 0 ? (
        <p className="text-sm text-zoomuted">{t('reviewSection.noPetChanges')}</p>
      ) : isNewPet ? (
        <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-2">
          {changes.map(function renderDetail(change) {
            return (
              <div key={change.label}>
                <dt className="text-[11px] font-semibold text-zoomuted">{change.label}</dt>
                <dd className="text-sm font-semibold text-zooindigo">{change.proposedLabel}</dd>
              </div>
            );
          })}
        </dl>
      ) : (
        <div className="space-y-2">
          <div className="hidden sm:grid grid-cols-3 gap-2 text-[11px] font-semibold uppercase tracking-wider text-zoomuted">
            <span />
            <span>{t('reviewSection.currentLabel')}</span>
            <span>{t('reviewSection.proposedLabel')}</span>
          </div>
          {changes.map(function renderChange(change) {
            return (
              <div key={change.label} className="grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-2 text-sm">
                <span className="text-zoomuted font-semibold sm:font-normal">{change.label}</span>
                <span className="text-zoomuted">
                  <span className="sm:hidden mr-1 text-[11px] font-semibold uppercase tracking-wider">
                    {t('reviewSection.currentLabel')}:{' '}
                  </span>
                  <span className="line-through">{change.currentLabel}</span>
                </span>
                <span className="text-zooindigo font-semibold">
                  <span className="sm:hidden mr-1 text-[11px] font-semibold uppercase tracking-wider text-zoomuted">
                    {t('reviewSection.proposedLabel')}:{' '}
                  </span>
                  {change.proposedLabel}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
